import {default as cx} from "classnames"
import {useState} from "react"

import {PreceptorOrientationDetails} from "./PreceptorOrientationDetails"
import {getLocaleDate, scoreBadge, ORIENTATION_STATUS} from "../../utilities/general"

export const PreceptorCompletedOrientationSummary = ({orientation}) => {
    const [showDetails, setShowDetails] = useState(false)
    const osrMax = scoreBadge(orientation.percent_of_max_osr_score, 100)

    return (
        <div className="card mt-4 border border-gray-400">
            <div className="card-header flex-column flex-sm-row align-items-stretch align-items-sm-center py-4 py-sm-0 gap-3 gap-sm-4">
                <div className="card-title text-dark fw-bold gap-4 flex-fill m-0">
                    <div className="d-flex flex-row align-items-start align-items-sm-center gap-2 flex-fill">
                        <div className="d-flex flex-column fs-5 flex-fill">
                            <div className="d-flex flex-row">{orientation.name}</div>
                            <div className="d-flex flex-row flex-wrap align-items-center gap-2 gap-sm-3">
                                <span className="text-dark fw-bold d-block fs-7">
                                    Status: {orientation.orientation_status}
                                </span>
                                <span className="fw-semibold d-block fs-7">
                                    <i
                                        className={cx(
                                            "fas me-1 fs-5",
                                            orientation.orientation_status_id === ORIENTATION_STATUS.COMPLETED
                                                ? "fa-calendar-check text-success"
                                                : "fa-calendar-xmark text-danger"
                                        )}
                                    ></i>
                                    {getLocaleDate(orientation.end_date)}
                                </span>
                            </div>
                        </div>
                        <div className="d-flex flex-row align-items-center ms-2 ms-sm-4">
                            {osrMax.score && (
                                <div className={cx("badge px-4 py-3", osrMax.background, osrMax.textColor)}>
                                    {osrMax.score}%
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="card-toolbar gap-4 flex-shrink-0 w-100 w-sm-auto">
                    <button
                        className={cx(
                            "btn btn-light-primary rotate collapsible w-100 w-sm-auto justify-content-center",
                            {collapsed: !showDetails}
                        )}
                        onClick={() => setShowDetails(!showDetails)}
                    >
                        Details
                        <span className="d-flex flex-center rotate-180 ms-3">
                            <i className="fas fa-arrow-circle-down fs-3"></i>
                        </span>
                    </button>
                </div>
            </div>
            {showDetails && <PreceptorOrientationDetails orientationId={orientation.id} />}
        </div>
    )
}
